import { Spin, Typography } from "@arco-design/web-react";

import "./CustomizationWorkbenchOpeningPage.css";

/**
 * 增定制创建过程中预开的过渡页。
 * 地址栏展示同源业务路径，避免 about:blank 被误认为报错。
 */
export function CustomizationWorkbenchOpeningPage() {
  return (
    <div
      className="customization-workbench-opening"
      data-testid="customization-workbench-opening"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Spin size={32} />
      <Typography.Title heading={5} className="customization-workbench-opening__title">
        正在创建定制
      </Typography.Title>
      <Typography.Text type="secondary">请稍候，创建完成后将自动进入工作台…</Typography.Text>
    </div>
  );
}
